import { render, staticRenderFns } from "./ImportTag.vue?vue&type=template&id=513505ea&"
import script from "./ImportTag.vue?vue&type=script&lang=js&"
export * from "./ImportTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports